// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"

const study = `/:vaultId/studies/:globalSponsorStudyId`
const sites = `${study}/sites`
const reports = `${study}/reports`
const site = `${sites}/:siteId`
const participants = `${site}/participants`
const compliance = `${study}/compliance`

const studyRouteNames = {
  study: createRoutePath(study),
  studyOverview: createRoutePath(`${study}/overview`),
  sites: createRoutePath(sites),
  site: createRoutePath(site),
  siteOverview: createRoutePath(`${site}/overview`),
  participants: createRoutePath(participants),
  participant: createRoutePath(`${participants}/:participantId`),
  reports: createRoutePath(reports),
  surveyDataReport: createRoutePath(`${reports}/survey-data`),
  participantEventsReport: createRoutePath(`${reports}/participant-events`),
  participantGroupsReport: createRoutePath(`${reports}/participant-groups`),
  complianceReport: createRoutePath(`${reports}/compliance`),
  sponsorAuditReport: createRoutePath(`${reports}/sponsor-audit`),
  siteUserActionReport: createRoutePath(`${reports}/site-user-action`),
  siteClinicalDataReport: createRoutePath(`${reports}/site-clinical-data`),
  siteAuditReport: createRoutePath(`${reports}/site-audit`),
  dataChangesReport: createRoutePath(`${reports}/data-changes`),
  /**
   * Use eventGroupId because this is stable across collection upversions
   */
  ruleReport: createRoutePath(`${reports}/rule/:eventGroupId`),
  customExportReport: createRoutePath(`${reports}/custom/:customExportId`),
  dataChanges: createRoutePath(`${study}/datachanges`),
  compliance: createRoutePath(compliance),
  complianceStudy: createRoutePath(`${compliance}/study`),
  complianceDimension: createRoutePath(`${compliance}/:complianceDimension`),
}

export default studyRouteNames
